/* eslint no-console: 0 */

export type LogLevel = 'none' | 'error' | 'warn' | 'log' | 'info' | 'debug';

export type Logger = Console;

let logger: Logger | null = null;

const dummy = () => {};

/**
 * Creates a console wrapper with logging level rules.
 *
 * @param level log level
 * @returns logger instance
 */
export const createLogger = (level: LogLevel) => {
  if (logger) {
    return logger;
  }

  logger = { ...console };

  if (level !== 'debug') {
    logger.debug = dummy;
  }

  if (level !== 'info' && level !== 'debug') {
    logger.info = dummy;
  }

  if (level !== 'log' && level !== 'info' && level !== 'debug') {
    logger.log = dummy;
  }

  if (level !== 'warn' && level !== 'log' && level !== 'info' && level !== 'debug') {
    logger.warn = dummy;
  }

  if (level !== 'error' && level !== 'warn' && level !== 'log' && level !== 'info' && level !== 'debug') {
    logger.error = dummy;
  }

  return logger;
};

export const useLogger = () => {
  if (!logger) {
    throw new Error('logger instance is not initialized');
  }

  return logger;
};
